import { useQuery } from 'react-query';
import axios from 'axios';
import { SECOND } from 'time-constants';

import { apiConfig } from '@constants';

import { replaceTemplateValues } from '../../helpers/StringUtils';

const getAlertTileInventory = async (productKey: number) => {
  const inventoryURL = replaceTemplateValues(apiConfig.TWC_API_MAP_ALERTS_INVENTORY, {
    productKey,
  });

  return await axios.get(inventoryURL);
};

export const useGetAlertTileInventory = (productKey: number) =>
  useQuery(`getAlertTileInventory-${productKey}`, () => getAlertTileInventory(productKey), {
    refetchInterval: 90 * SECOND,
    refetchOnWindowFocus: false,
  });
